import { render, staticRenderFns } from "./Riwayat.vue?vue&type=template&id=734a6987&scoped=true"
import script from "./Riwayat.vue?vue&type=script&lang=js"
export * from "./Riwayat.vue?vue&type=script&lang=js"
import style0 from "./Riwayat.vue?vue&type=style&index=0&id=734a6987&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734a6987",
  null
  
)

export default component.exports